export default {
    data: () => ({
        btnLoading: false,
        server_errors: {
            title: '',
            receiver_name: '',
            phone: '',
            address: '',
            postal_code: '',
            transport_type: '',
            address_country: '',
            address_district: '',
        },
        transportTypes: [
            { id: 'normal', name: 'ປົກກະຕິ ( Normal )' },
            { id: 'air_freight', name: 'ທາງຍົນ ( Air Freight )' },
            { id: 'railway', name: 'ທາງລົດໄຟ ( Railway )' },
        ],
        addressCountries: [
            { id: 'zh', name: 'ຈີນ ( ZH )' },
            { id: 'th', name: 'ໄທ ( TH )' },
        ],
    }),
    methods: {
        ValidateForm() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.EditItem();
                }
            });
        },
        EditItem() {
            this.btnLoading = true;
            const payload = {
                title: this.shippingAddress.title || null,
                receiver_name: this.shippingAddress.receiver_name,
                phone: this.shippingAddress.phone,
                address: this.shippingAddress.address,
                postal_code: this.shippingAddress.postal_code || null,
                transport_type: this.shippingAddress.transport_type,
                address_country: this.shippingAddress.address_country,
                address_district: this.shippingAddress.address_district,
            };
            this.$http.put('shipping-address/' + this.shippingAddress.id, payload).then((res) => {
                if (res.data && res.data.error === false) {
                    setTimeout(() => {
                        this.btnLoading = false;
                        this.$emit('close');
                        this.$emit('success');
                        this.$notification.OpenNotification_EditItem_OnSuccess('top-right', 'dark', 3000);
                    }, 300);
                } else {
                    this.btnLoading = false;
                    this.$notification.OpenNotification_Error_Server('top-right', 'danger', 3000);
                }
            }).catch((error) => {
                this.btnLoading = false;
                if (error.response && error.response.status === 422) {
                    const obj = error.response.data.errors || {};
                    for (const [key, value] of Object.entries(obj)) {
                        this.server_errors[key] = value[0];
                    }
                } else {
                    this.$notification.OpenNotification_Error_Server('top-right', 'danger', 3000);
                }
            });
        },
    },
};
